// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.word-search-editor-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* margin: 10px; */
  height: 100%;
}

.word-search-editor-panel {
  flex: 1 1;
  height: 100%;
  background-color: rgba(112, 128, 144, 0.171);
  border-radius: 2px;
}

.word-search {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.word-search-editor-content-container {
  display: flex;
  flex-direction: column;
  width: -moz-fit-content;
  width: fit-content;
  height: -moz-fit-content;
  height: fit-content;
  max-width: 95%;
  justify-content: center;
  align-items: center;

}

/* Table Css */
.word-search table {
  border-collapse: collapse;
}

.word-search td {
  width: 30px;
  height: 30px;
  text-align: center;
  border: 1px solid #000;
  font-size: 20px;
  cursor: pointer;
}

.word-search td:hover {
  background: rgba(71, 114, 255, 0.363);
}

.word-search td.selected {
  background: rgba(255, 252, 71, 0.575);
}

.word-search-game-word-header-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  border-width: 1px;
  border-color: #000;
  border-style: solid;
  padding: 5px;
  background: rgba(232, 240, 220, 0.308);
  align-items: center;
  margin: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Games/WordSearch/WordSearch.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;EAClB,wBAAmB;EAAnB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA,cAAc;AACd;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".word-search-editor-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  /* margin: 10px; */\n  height: 100%;\n}\n\n.word-search-editor-panel {\n  flex: 1;\n  height: 100%;\n  background-color: rgba(112, 128, 144, 0.171);\n  border-radius: 2px;\n}\n\n.word-search {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.word-search-editor-content-container {\n  display: flex;\n  flex-direction: column;\n  width: fit-content;\n  height: fit-content;\n  max-width: 95%;\n  justify-content: center;\n  align-items: center;\n\n}\n\n/* Table Css */\n.word-search table {\n  border-collapse: collapse;\n}\n\n.word-search td {\n  width: 30px;\n  height: 30px;\n  text-align: center;\n  border: 1px solid #000;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.word-search td:hover {\n  background: rgba(71, 114, 255, 0.363);\n}\n\n.word-search td.selected {\n  background: rgba(255, 252, 71, 0.575);\n}\n\n.word-search-game-word-header-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  border-width: 1px;\n  border-color: #000;\n  border-style: solid;\n  padding: 5px;\n  background: rgba(232, 240, 220, 0.308);\n  align-items: center;\n  margin: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
